@if (layout === 'section') {
  <h3 class="cl-spacing-none">Encode details</h3>
  <ng-container *ngTemplateOutlet="fields"></ng-container>
} @else {
  <div class="col-12">
    <div class="card">
      <div class="card-header">Encode details</div>
      <div class="card-body">
        <ng-container *ngTemplateOutlet="fields"></ng-container>
      </div>
    </div>
  </div>
}

<ng-template #fields>
  <div class="row" [formGroup]="form">
    <div class="col-12 col-md-6">
      <label [for]="idPrefix + 'input_brefix'" class="form-label">Source folder </label>
      <input disabled [id]="idPrefix + 'input_brefix'" type="text" formControlName="input_brefix" [class.invalid]="showInvalid('input_brefix')">
      @if (form.controls.input_brefix.errors?.required) {
        <p class="invalid-feedback">This field is
        required.</p>
      }
      @if (!form.controls.input_brefix.errors) {
        <p class="valid-feedback">You can
          <a [routerLink]="'/files/browse/' + form.controls.input_brefix.value  ">navigate to the source folder</a>
        </p>
      }
    </div>
    <div class="col-12 col-md-6">
      <label [for]="idPrefix + 'po_item_id'" class="form-label">{{ poItemIdLabel }}<span class="required">*</span></label>
      <input [id]="idPrefix + 'po_item_id'" type="text" formControlName="po_item_id" pattern="[A-Za-z0-9_\-.]+"
             [class.invalid]="showInvalid('po_item_id')">
      @if (form.controls.po_item_id.errors?.required) {
        <p class="invalid-feedback">This field is
        required.</p>
      } @else if (form.controls.po_item_id.errors?.pattern) {
        <p class="invalid-feedback">Only letters, numbers, underscores, hyphens, and
        periods are allowed (no spaces).</p>
      } @else if (form.controls.po_item_id.errors?.s3TagValueTooLong; as tooLong) {
        <p class="invalid-feedback">The title is too long: it encodes to {{ tooLong.encoded }} of at most {{ tooLong.max }}
          characters. Characters outside <code>A-Z a-z 0-9 + - = . _ :</code> need three characters
          each when encoded.</p>
      } @else if (!form.controls.po_item_id.errors && poItemIdHelp) {
        <p class="valid-feedback">{{ poItemIdHelp }}</p>
      }
    </div>
  </div>
</ng-template>
